export enum ColorSegmentColor {
  VeryLow = '#FD9696',
  Low = '#FFC799',
  Medium = '#FFDE85',
  High = '#C9E5AC',
  VeryHigh = '#A8D98D',
}

export enum NeutralColorSegment {
  Edge = '#C1C7D0',
  NearEdge = '#DFE1E6',
  Center = '#EBECF0',
}

export type ChartSegmentColor = ColorSegmentColor | NeutralColorSegment;
